import { router } from './router';

export const Pages = {
	router,
};
